<template>
  <div class="recruit">
    <div class="box">
      <label>招募对象</label>
      <div class="b1">
        <p>1.优质的个人</p>
        <p>2.拥有优质达人资源的工会</p>
      </div>
    </div>
    <div class="box">
      <label>联系方式</label>
      <div class="b2">
        <p>微信联系</p>
        <p>angemo123</p>

        <button class="btn" data-clipboard-text="angemo123">复制微信号</button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.recruit {
  width: 100%;
  min-height: 100vh;
  background: #7475ed url("../assets/image/recruit/recruit_back.png") no-repeat
    top center;
  background-size: 100% auto;
  box-sizing: border-box;
  padding: 11.29rem 0.48rem 0.71rem;

  .box {
    width: 6.54rem;
    min-height: 4.2rem;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    position: relative;

    &:nth-child(1){
        margin-bottom: 0.4rem;
    }

    label {
      width: 3.26rem;
      height: 1.19rem;
      position: absolute;
      left: -0.48rem;
      top: 0.63rem;
      background: url("../assets/image/recruit/recruit_item.png") no-repeat top
        left;
      background-size: 100% auto;
      color: #fff;
      box-sizing: border-box;
      padding: 0.21rem 0 0 0.71rem;
      line-height: 0.98rem;
      font-size: 0.46rem;
      overflow: hidden;
    }

    .b1 {
      padding: 2.18rem 0 0 0.79rem;
      color: #666666;
      font-size: 0.34rem;
      p {
        margin-bottom: 0.12rem;
      }
    }

    .b2 {
      text-align: center;
      padding-top: 2.22rem;
      color: #666666;
      font-size: 0.3rem;

      p {
        margin-bottom: 0.12rem;

        &:nth-child(2) {
          font-size: 0.5rem;
          margin-bottom: 0.25rem;
        }
      }
      button {
        color: #fff;
        font-size: 0.3rem;
        width: 4.7rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background: rgba(121, 122, 237, 1);
        border-radius: 0.4rem;
        cursor: pointer;
        margin-bottom: 0.5rem;
        outline: none;
      }
    }
  }
}
</style>
<script>
import ClipboardJS from "clipboard";
export default {
  mounted() {
    var self = this;
    var clipboard = new ClipboardJS(".btn");
    clipboard.on("success", function (e) {
      self.$alert({
        text: "复制成功",
      });
      e.clearSelection();
    });
  },
  methods: {
    clipboardData() {
      window.clipboardData.setData("Text", "angemo123");
    },
  },
};
</script>